module.exports = __webpack_public_path__ + "img/a2.2c4ae228.png";